module.exports = __webpack_public_path__ + "img/cockfight-menu-icon.b32da7aa.svg";